import { API } from 'aws-amplify';
import { getAppVersion } from '../../utils/helpers';
import store from '../store';

/**
 * Create a graphQL query
 * @param query
 * @param variables
 * @param addRestIdToVariables
 * @returns {Promise<T>}
 */
export const graphQLQuery = (query, variables, addRestIdToVariables = false, overrideRestId) => {
  const state = store.getState();
  const restId = overrideRestId ?? state.restaurant.data?.objectId;

  let data = variables;
  if (addRestIdToVariables) {
    data = { ...variables, restId };
  }

  return API.graphql(
    {
      query,
      variables: data,
    },
    {
      'rest-id': restId,
      'app-version': getAppVersion(),
      'X-Api-Environment': process.env.REACT_APP_API_ENVIRONMENT ?? 'production',
    },
  );
};
